import {useState,useEffect, useCallback} from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";

import {TenantFrontendApi_DeleteUserLicence, TenantFrontendApi_GetUserResetToken, TenantFrontendApi_GetTenant,TenantFrontendApi_GetUserList,TenantFrontendApi_GetLicenceList,TenantFrontendApi_DeleteTenantLicence,TenantFrontendApi_BlockUser, TenantFrontendApi_DeleteTenant, TenantFrontendApi_DeleteUser, TenantFrontendApi_PostSendEmail} from "./TenantFrontendApi";
import { Translate } from "./Translator"

import Header from "./Header"
import MainMenu from "./MainMenu"
import BlueBar from "./BlueBar"
import Footer from "./Footer"

import HomeLogo from "./Assets/HomeLogo.png"
import SearchButton from "./Assets/SearchButton.png"
import EditLogo from "./Assets/EditLogo.png";
import CloseLogo from "./Assets/CloseLogo.png"
import CloseLogoDelete from "./Assets/CloseLogo.jpg"
import EditInformationLogo from "./Assets/EditInformationlogo.jpg"
import PlusIcon from "./Assets/PlusIcon.jpg"
import Block from './Assets/Block.png'
import Envelop from './Assets/EnvelopLogo.png'
import CRMAdminlogo from './Assets/CRMAdminLogo.jpg'
import TenantAdminLogo from './Assets/TenantAdminLogo.png'
import TestTenantIcon from './Assets/TestTenant.png'
import DeleteIcon from "./Assets/DeleteIcon.png"

import './Tenant.css';

function Tenant(){

    const [mRepaint,SetRepaint] = useState()
    const navigate = useNavigate();

    const [mTenantGuid, SetTenantGuid] = useState()
    const [mTenant, SetTenant] = useState(null)
    const [mDeletedTenantGuid,SetDeletedTenantGuid] = useState("")

    const [mLicenceList,SetLicenceList]=useState([])
    const [mExpireLicence,SetExpireLicence] = useState("")
    const [mExpireLicenceCount,SetExpireLicenceCount] = useState(1)
    
    const [mUserSearchValue,SetUserSearchValue] = useState("")
    const [mDeleteUser,SetDeleteUser] = useState("")
    const [mInvitedUser,SetInvitedUser] = useState("")
    const [mAllUserList,SetAllUserList] = useState([])

    const[mSuperTenantName,SetSuperTenantName] = useState("")

    const [mDeletingAResellerTenant,SetDeletingAResellerTenant] = useState(false)

    const location = useLocation();
    const [mShowGetLicenseCount, SetShowGetLicenseCount] = useState(false)
    const [mExpringLicenseError, SetExpringLicenseError] = useState("")
    const [mExpringLicenseErrorCauseOfAssignedToUsers ,SetExpringLicenseErrorCauseOfAssignedToUsers] = useState("")
    const [mShowPopUpErrorEditingTenant,SetShowPopUpErrorEditingTenant] = useState("")
    const [mShowPopUpErrorDeletingTenant,SetShowPopUpErrorDeletingTenant] = useState("")
    const [mShowPopUpErrorBuyingLicenses,SetShowPopUpErrorBuyingLicenses] = useState("")

    const [isSuperTenant, setIsSuperTenant] = useState(false);
    const [mLastUserInResellerAccount, setLastUserInResellerAccount] = useState()
    const superTenantGuid = sessionStorage.getItem("SuperTenantGuid")
    const [mShowDeleteTenantTable, SetShowDeleteTenantTable] = useState()
    
    let mUserResetToken;
    

    useEffect(() => {

        async function GetTenant(aTenantGuid) {
            try
            {
                //console.log("Getting tenant")
                const TenantResponse = await TenantFrontendApi_GetTenant(sessionStorage.getItem("token"),aTenantGuid)
                SetTenant(TenantResponse.data)
            }

            catch (ex)
            {
                var error = ex;
                var errorCode = null;
                try 
                {
                    if (ex.response && ex.response.status) {
                        errorCode = ex.response.status;
                        console.log(errorCode)
                    }
                    navigate('../error?errorcode=' + errorCode + '&error=tenant')
                    error = ex.response.data.Exception;
                } catch {}  
                console.log("Error: " + error);
            }
        }

        async function GetUsers(aTenantGuid)
        {
            try
            {
                //console.log("Getting Users")
                const UserListResponse = await TenantFrontendApi_GetUserList(sessionStorage.getItem("token"),aTenantGuid)
                console.log("UserList: " + UserListResponse.data)
                SetAllUserList(UserListResponse.data)
            }
            catch(ex)
            {
                var error = ex;
                try { error = ex.response.data.Exception; } catch {}  
                console.log("Error: " + error);
            }
        }

        async function GetLicences(aTenantGuid)
        {
            try{
                //console.log("Getting Licenses")
                const LicenceListResponse = await TenantFrontendApi_GetLicenceList(sessionStorage.getItem("token"),aTenantGuid)
                SetLicenceList(LicenceListResponse.data)
            }
            catch(ex){
                var error = ex;
                try { error = ex.response.data.Exception; } catch {}  
                console.log("Error: " + error);
            }
        }
       
        //Get the parameters from the URL                            
        const windowUrl = window.location.search;
        const params = new URLSearchParams(windowUrl);
        const ciParams = new URLSearchParams();
        for (const [name, value] of params) { ciParams.append(name.toLowerCase(), value); }
        const tenantguid = ciParams.get('tenantguid')
        SetTenantGuid(tenantguid)

        GetTenant(tenantguid)
        GetUsers(tenantguid)
        GetLicences(tenantguid)

        setIsSuperTenant(sessionStorage.getItem("IsSuperTenant") === "1" ? true : false)
        SetShowDeleteTenantTable(sessionStorage.getItem("IsSuperTenant") === "1" && tenantguid === sessionStorage.getItem("SuperTenantGuid") ? false : true)

    }, [navigate]);

    
    useEffect(() => {
        async function GetSuperTenantNam() {
            try {
                console.log("Getting super tenant");
                
                // Retrieve the token from session storage
                const token = sessionStorage.getItem("token");
                if (!token) {
                    throw new Error("Token is missing from session storage.");
                }
                
                // Fetch the tenant details
                const TenantResponse = await TenantFrontendApi_GetTenant(sessionStorage.getItem("token"), mTenant.SuperTenantGuid);
                
                // Check if the response contains expected data
                if (!TenantResponse || !TenantResponse.data || !TenantResponse.data.Company) {
                    throw new Error("Unexpected response format from Tenant API.");
                }

                // Set the super tenant name
                SetSuperTenantName(TenantResponse.data.Company);
            } catch (ex) {
                // Log detailed error information for debugging
                if (ex.response) {
                    console.error("API Error:", ex.response.data?.Exception || ex.response.statusText);
                    console.error("Status Code:", ex.response.status);
                    console.error("Error Details:", ex.response.data);
                } else if (ex.message) {
                    console.error("Error:", ex.message);
                } else {
                    console.error("Unexpected error:", ex);
                }
            }  
        }
    
        if (mTenant && !mTenant.IsSuperTenant)
        {
            GetSuperTenantNam();
        }
    }, [mTenant, navigate]);

    useEffect(() => {
        const elementId = location.hash.substring(1);
        const checkAndScroll = () => {
          const targetElement = document.getElementById(elementId);
          if (targetElement) {
            targetElement.scrollIntoView({ behavior: "smooth" });
          } else {
            console.warn(`Element with id '${elementId}' not found, retrying...`);
            setTimeout(checkAndScroll, 100); // Retry after a short delay
          }
        };
    
        if (location.hash) {
          checkAndScroll();
        }
      }, [location]);

    function EditInformationButton(aTenantGuid){
        
        if(sessionStorage.getItem("IsSuperTenant") === "1" && sessionStorage.getItem("ManageTenants") === "0")
        {
            SetShowPopUpErrorEditingTenant("You do not have the privilege to edit tenants. Please contact your provider to access.")
        }
        else{
            navigate('../edittenant?tenantguid='+aTenantGuid)
        }
    }

    function BuyLicence(){
        if(sessionStorage.getItem("IsSuperTenant") === "1" && sessionStorage.getItem("ManageLicenses") === "0")
        {
            SetShowPopUpErrorBuyingLicenses("You do not have the privilege to manage licenses. Please contact your provider to access.")
        }
        else
        {
            navigate('../buylicence?tenantguid=' + mTenantGuid)
        }
    }               

    function AddNewUserButton(aTenantGuid){
        navigate('../addnewuser?tenantguid=' + mTenant.TenantGuid)
    }

    function ExpireLicence() {
        if (
            sessionStorage.getItem("IsSuperTenant") === "1" &&
            sessionStorage.getItem("ManageLicenses") === "0"
        ) {
            SetShowPopUpErrorBuyingLicenses(
                "You do not have the privilege to manage licenses. Please contact your provider to access."
            );
            return; // Don't continue if no permissions
        }
    
        const NumberOfLicesesTenantHave = parseInt(mExpireLicence.Count, 10);
        let NumberOfLicesesTenatWantToDelete = parseInt(mExpireLicenceCount, 10);
    
        console.log("NumberOfLicesesTenantHave:", NumberOfLicesesTenantHave);
        console.log("NumberOfLicesesTenatWantToDelete:", NumberOfLicesesTenatWantToDelete);
    
        if (isNaN(NumberOfLicesesTenantHave) || isNaN(NumberOfLicesesTenatWantToDelete)) {
            console.error("Invalid input: one of the values is not a valid number.");
            return;
        }
    
        // Adjust if delete amount is more than available
        if (NumberOfLicesesTenantHave - NumberOfLicesesTenatWantToDelete < 0) {
            SetShowGetLicenseCount(false);
            NumberOfLicesesTenatWantToDelete = NumberOfLicesesTenantHave; // just local
            SetExpireLicenceCount(NumberOfLicesesTenantHave); // just updates UI, async
        }
    
        const UserWithThisLicense = FilterUserWithExpireLicense();
    
        if (UserWithThisLicense?.length > 0) {
            if (
                NumberOfLicesesTenantHave - NumberOfLicesesTenatWantToDelete <
                UserWithThisLicense.length
            ) {
                SetShowGetLicenseCount(false);
                SetExpringLicenseErrorCauseOfAssignedToUsers(
                    "The user or users of this tenant have this license. By expiring this number of licenses, the license will also expire for the users!"
                );
                return;
            }
        }
    
        SetShowGetLicenseCount(false);
        return DeleteTenantLicence(NumberOfLicesesTenatWantToDelete);
    }

    function FilterUserWithExpireLicense() {
        if (!Array.isArray(mAllUserList)) {
            console.log("mAllUserList is undefined or not an array.");
            return [];
        }
        
        return mAllUserList.filter(user =>
            user.LicenceGuid?.includes(mExpireLicence?.LicenceGuid)
        );
    }
    
    async function DeleteTenantLicence(aExpireLicenseCount)
    {
        try
        {
            console.log("Deleting Licence")
            const DeleteLicecnceResponse = await TenantFrontendApi_DeleteTenantLicence(sessionStorage.getItem("token"),mTenantGuid,mExpireLicence.LicenceGuid,aExpireLicenseCount)
            console.log(DeleteLicecnceResponse.data)
            SetExpireLicence("")

            const LicenceListResponse = await TenantFrontendApi_GetLicenceList(sessionStorage.getItem("token"),mTenantGuid)
            SetLicenceList(LicenceListResponse.data)

            SetRepaint(!mRepaint)
        }

        catch(ex){
            console.log(ex.response.data)
            var error = ex;
            try { error = ex.response.data.Exception; } catch {}  
            console.log("Error: " + error);
        }
    }

    function handleDeleteTenant(aTenantGuid)
    {
        if(sessionStorage.getItem("IsSuperTenant") === "1" && sessionStorage.getItem("ManageTenants") === "0")
        {
            SetShowPopUpErrorDeletingTenant("You do not have the privilege to delete tenants. Please contact your provider to access.")
        }
        else if (sessionStorage.getItem("IsSuperTenant") === "1" && aTenantGuid === sessionStorage.getItem("SuperTenantGuid") )
        {
            SetShowPopUpErrorDeletingTenant("You cannot delete your own tenant!")
        }
        else
        {
            if(mTenant.IsSuperTenant)
            {
                //Deleting a reseller tenant
                SetDeletingAResellerTenant(true)
            }
            else
            {
                //Deleting a normal tenant.
                SetDeletedTenantGuid(aTenantGuid)
            }
        }
    }

    async function DeleteTenant() 
    {
        try
        {
            console.log("Deleting tenant")
            const DeleteTenantResponse = await TenantFrontendApi_DeleteTenant(sessionStorage.getItem("token"),mTenant.TenantGuid)
            console.log(JSON.stringify(DeleteTenantResponse))
            SetDeletedTenantGuid("")
            SetDeletingAResellerTenant(false)
            navigate('../reseller')
        }
        catch (ex)
        {
            var error = ex;
            try { error = ex.response.data.Exception; } catch {}  
            console.log("Error: " + error);
            SetDeletedTenantGuid("")
            SetDeletingAResellerTenant(false)
        }
    }

    function TenantPage()
    {
        navigate('../reseller')
    }

    function HomePage()
    {
        return(
            navigate('../')
        )
    }

    function languageChanged()
    {
        SetRepaint(!mRepaint)
    }

    async function DeleteUser()
    {
        try
        {
            console.log("Deleting User")
            const DeleteUserResponse = await TenantFrontendApi_DeleteUser(sessionStorage.getItem("token"),mDeleteUser.UserGuid)
            console.log(DeleteUserResponse)
            SetDeleteUser("")

            const UserListResponse = await TenantFrontendApi_GetUserList(sessionStorage.getItem("token"),mTenantGuid)
            SetAllUserList(UserListResponse.data)   
        }

        catch(ex){
            console.log(ex.response.data)
            var error = ex;
            try { error = ex.response.data.Exception; } catch {}  
            console.log("Error: " + error);
            SetDeleteUser("")
        }
    }

    async function BlockUser(aUser)
    {
        try
        {
            console.log("Blocking User")
            await TenantFrontendApi_BlockUser(sessionStorage.getItem("token"),aUser.UserGuid,mTenantGuid,aUser.IsActive)
            const UserListResponse = await TenantFrontendApi_GetUserList(sessionStorage.getItem("token"),mTenantGuid)
            SetAllUserList(UserListResponse.data) 
        }

        catch(ex){
            console.log(ex.response.data)
            var error = ex;
            try { error = ex.response.data.Exception; } catch {}  
            console.log("Error: " + error);
        }
    }

    function InviteUser(aUser)
    {
        SetInvitedUser(aUser)
    }

    async function SendEmail(){
        try {
            await GetTheResetToken();
            console.log("User reset token: " + mUserResetToken); // Ensure mUserResetToken is correctly set
    
            if (mUserResetToken) {
                return await SendInviteEmail(mUserResetToken);
            } else {
                console.error("mUserResetToken is empty or not set.");
            }
        } catch (ex) {
            console.error("Error sending email:", ex);
        }
    }                                                                     
    
    async function GetTheResetToken()
    {
        try {
            console.log("Getting the user reset token");

            const UserResetTokenResponse = await TenantFrontendApi_GetUserResetToken(
                sessionStorage.getItem("token"),
                sessionStorage.getItem("resellerguid"),
                mInvitedUser.UserGuid
            );

            // Log the entire response to ensure the token is present
            console.log("UserResetTokenResponse:", UserResetTokenResponse);

            // Check if the ResetToken is present in the response data
            if (UserResetTokenResponse.data && UserResetTokenResponse.data.ResetToken) {
                SetUserResetToken(UserResetTokenResponse.data.ResetToken);
            } else {
                console.error("ResetToken not found in response");
            }

        } catch (ex) {
            let errorMessage = "Unknown error";
            if (ex && ex.response && ex.response.data) {
                errorMessage = ex.response.data.Exception || "No exception details";
            }
            console.error("Error getting reset token: " + errorMessage);
        }
    }

    function SetUserResetToken(token) {
        // Update the global or higher scope variable mUserResetToken
        mUserResetToken = token;
        console.log("mUserResetToken set to:", mUserResetToken); // Log for debugging
    }

    async function SendInviteEmail(aUserResetToken)
    {
        try
        {
            console.log("Sending User Email")
            const SendMessageResponse = await TenantFrontendApi_PostSendEmail(sessionStorage.getItem("token"),mInvitedUser.Email,mInvitedUser.Name,aUserResetToken)
            console.log(SendMessageResponse)
            SetInvitedUser("")
        }

        catch(ex){
            console.log(ex.response.data)
            var error = ex;
            try { error = ex.response.data.Exception; } catch {}  
            console.log("Error: " + error);
        }
    }

    function ShowAnimationExpireLicense(aLicense)
    {
        if(sessionStorage.getItem("IsSuperTenant") === "1" && sessionStorage.getItem("ManageLicenses") === "0")
        {
            SetShowPopUpErrorBuyingLicenses("You do not have the privilege to manage licenses. Please contact your provider to access.")
        }
        else
        {
            SetExpireLicence(aLicense);

            SetShowGetLicenseCount(true);
        }
    }

    async function ExpireLicesesOfUsers() {

        SetExpringLicenseErrorCauseOfAssignedToUsers(""); 
        
        let UserWithThisLicense = FilterUserWithExpireLicense();

        // Limit the users based on mExpireLicenceCount
        let usersToRemove = UserWithThisLicense.slice(0, mExpireLicenceCount);

        // Use map to create an array of promises and wait for all to finish
        await Promise.all(
            usersToRemove.map(user =>
                TenantFrontendApi_DeleteUserLicence(
                    sessionStorage.getItem("token"),
                    user.UserGuid,
                    mTenant.TenantGuid
                )
            )
        );

        // Fetch updated user list after deletions are completed
        const UserListResponse = await TenantFrontendApi_GetUserList(sessionStorage.getItem("token"), mTenantGuid);
        SetAllUserList(UserListResponse.data || []);

        // Expire the license for the tenant **AFTER** updating the user list
        await DeleteTenantLicence(mExpireLicenceCount);
    
        // Trigger re-render
        SetRepaint(prev => !prev);
    }

    function deleteUserHandler(aUser)
    {
        console.log("lastUserInResellerAccount: " + mLastUserInResellerAccount)
        console.log("isSuperTenant:" + isSuperTenant)
        if(sessionStorage.getItem("IsSuperTenant") === "1" && aUser.TenantGuid === sessionStorage.getItem("SuperTenantGuid") && aUser.IsTenantAdmin === true && aUser.UserGuid === sessionStorage.getItem("UserGuid"))
        {
            SetShowPopUpErrorDeletingTenant("You cannot delete your admin user account. Please contact your provider for assistance")
        }
        else if (sessionStorage.getItem("IsSuperTenant") === "1" && aUser.TenantGuid === sessionStorage.getItem("SuperTenantGuid") && aUser.IsTenantAdmin === true)
        {
            SetShowPopUpErrorDeletingTenant("You cannot delete an admin user account from your own tenant")
        }
        else
        {
            SetDeleteUser(aUser)   
        }
    }

    const findTheLastTenantAdminUser = useCallback(() => {
    if (!Array.isArray(mAllUserList) || mAllUserList.length === 0) {
        console.warn("mAllUserList is not ready or empty");
        return;
    }

    const sortedUsers = [...mAllUserList].sort(
        (a, b) => new Date(b.Created) - new Date(a.Created)
    );
    const lastUser = sortedUsers[0];

    if (lastUser) {
        sessionStorage.setItem("LastUserInResellerAccount", lastUser.UserGuid);
        setLastUserInResellerAccount(lastUser.UserGuid);
        console.log("The latest user: " + lastUser.UserGuid);
    }
}, [mAllUserList, setLastUserInResellerAccount]);

useEffect(() => {
    if (isSuperTenant && superTenantGuid === mTenantGuid) {
        findTheLastTenantAdminUser(); // ✅ Now it works
    }
}, [mAllUserList, mTenantGuid, isSuperTenant, findTheLastTenantAdminUser, superTenantGuid]);




    if (!mTenant)
    {
        return(<span>{Translate("Retrieving data")}</span>)
    } 

    else
    {
        const UserFilterLC = mUserSearchValue.toLowerCase()
        const FilteredUserList = mAllUserList.filter(
            user => (
                user.Name.toLowerCase().includes(UserFilterLC) 
                || user.Email.toLowerCase().includes(UserFilterLC))
        )

        // Handle keypress for Enter key
        const handleKeyPress = (e) => {
            if (e.key === "Enter" && FilteredUserList.length === 1) {
                const user = FilteredUserList[0];
                navigate(`../user?userguid=${user.UserGuid}`);
            }
        };

        return(            
            <div>

                <Header onLanguageChanged={() => languageChanged()}/>
                
                <MainMenu MainMenuNumber={1} />

                <table width="1200" cellPadding={0} cellSpacing={0} align="center">
                    <tbody>                
                        <tr className="pagetop3">
                            <td colSpan={6} height="75" valign="bottom">
                                <table width="100%" cellPadding={0} cellSpacing={0} className="down10px width1200">
                                    <tbody>
                                        <tr height="60">
                                            <td
                                                width="100%"
                                                align="left"
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px',
                                                    flexWrap: 'nowrap'
                                                }}
                                            >
                                                {/* Home Logo */}
                                                <a
                                                    href="/"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        HomePage();
                                                    }}
                                                    title="Home"
                                                >
                                                    <img
                                                        alt="Home logo"
                                                        className="HomeLogo pointer"
                                                        src={HomeLogo}
                                                    />
                                                </a>

                                                {/* Separator */}
                                                <span className="blue">/</span>

                                                {/* Tenants */}
                                                <a
                                                    href="../tenants"
                                                    className="pointer bold black"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        TenantPage();
                                                    }}
                                                    title="Tenants"
                                                >
                                                    {Translate("Tenants")}
                                                </a>

                                                {/* Separator */}
                                                <span className="blue">/</span>

                                                {/* Company */}
                                                <span
                                                    className="bold black"
                                                    title={mTenant?.Company}
                                                >
                                                    {mTenant?.Company}
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <table className="width1200" align="center">
                    <tbody>
                        <tr className="pagetop6">
                            <td className="activetenants width30" colSpan={3} height="50" align="left">
                                {mTenant.Company} <span> </span>
                                {mTenant.IsTest ? (
                                    <img
                                    width="30"
                                    src={TestTenantIcon}
                                    alt="Is a test tenant"
                                    title="Demo tenant"
                                    />
                                ) : (
                                    <span></span>
                                )}
                            </td>

                            <td align="right" colSpan={2}>
                                {mTenant.IsSuperTenant && sessionStorage.getItem("IsSuperTenant") !== "1" ? 
                                    <table className="blackbackground borderradius">
                                        <tbody>
                                            <tr className="pointer" onClick={() => navigate('../supertenant?tenantguid=' + mTenant.TenantGuid)}>
                                                <td width="10"></td>
                                                <td><img className="width50" alt="Edit information" src={EditInformationLogo}/></td>
                                                <td><button className="noneborder blackbackground bold white pointer">{Translate("Assign subtenants")}</button></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    : ""
                                }
                            </td>
                        </tr>

                        <tr className="pagetop4">
                            <td colSpan={4} className="horizontalLine width30" >
                                <BlueBar/>
                            </td>
                        </tr>

                        <tr height="50"/>                
                         
                    </tbody>
                </table>

                <table className="width1200" align="center">
                    <tbody>

                        <tr className="pagetop6">
                            <td className="activetenants width30" colSpan={3} height="50" valign="left">
                                {Translate("Information")} 
                            </td>
                            <td colSpan={2} align="right">
                                <table  className="blackbackground borderradius">
                                    <tbody>
                                        <tr className="pointer" onClick={() => EditInformationButton(mTenantGuid)}>
                                            <td width="10"></td>
                                            <td><img className="width50" alt="Edit information" src={EditInformationLogo}/></td>
                                            <td><button className="noneborder blackbackground bold white pointer">{Translate("Edit information")}</button></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>

                        <tr>
                            <td colSpan={2} className="blue small">
                                {Translate("Created on")}{" "}
                                {new Date(mTenant.Created).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "long",
                                year: "numeric",
                                })}
                                
                                {sessionStorage.getItem("IsSuperTenant") === "1" || mTenant.IsSuperTenant === true ? <span/> :
                                    mTenant.SuperTenantGuid ? (
                                    <span>{Translate(", subtenant of " + mSuperTenantName)}</span>
                                    ) : (
                                    ""
                                    )
                                }

                            </td>
                        </tr>

                        <tr height="10"/> 

                        <tr className="contentenatable" >
                            <td className=" bold tenatsname borderbottomright" width="175">{Translate("Company name")}</td>
                            <td className=" companyname borderbottomright">{mTenant.Company}</td>
                            <td className=" freespacetable" width="40"></td>
                            <td className=" bold borderbottomright left-padding" width="200">{Translate("Phone")}</td>
                            <td className="left-padding borderbottomright">{mTenant.CompanyPhone}</td>
                        </tr>

                        <tr className="contentenatable" >
                            <td className=" bold tenatsname borderbottomright">{Translate("Address")}</td>
                            <td className=" companyname borderbottomright">{mTenant.CompanyAddressLine1}</td>
                            <td className=" freespacetable" width="40"></td>
                            <td className=" bold borderbottomright left-padding">{Translate("VAT number")}</td>
                            <td className=" left-padding borderbottomright">{mTenant.VATNumber}</td>
                        </tr>

                        <tr className="contentenatable" >
                            <td className=" bold tenatsname borderbottomright">{Translate("Address")} 2</td>
                            <td className=" companyname borderbottomright">{mTenant.CompanyAddressLine2}</td>
                            <td className=" freespacetable" width="40"></td>
                            <td className=" bold borderleft borderbottomright">{Translate("Custom id")}</td>
                            <td className="left-padding borderbottomright">{mTenant.CustomId}</td>
                        </tr>
                    
                        <tr className="contentenatable" >
                            <td className=" bold tenatsname borderbottomright">{Translate("Postal code")}</td>
                            <td className=" companyname borderbottomright">{mTenant.CompanyPostalCode}</td>
                            <td className=" freespacetable" width="40"></td>
                            <td className=" bold borderleft borderbottomright">{Translate("Tenant API settings")}</td>
                            <td className="left-padding borderbottomright">{mTenant.ApiSettings}</td>
                        </tr>

                        <tr className="contentenatable" >
                            <td className=" bold tenatsname borderbottomright">{Translate("City")}</td>
                            <td className=" companyname borderbottomright">{mTenant.CompanyCity}</td>
                            <td className=" freespacetable" width="40"></td>
                            <td className=" bold borderleft borderbottomright">{Translate("Country")}</td>
                            <td className="left-padding borderbottomright">{mTenant.CompanyCountry}</td>
                        </tr>

                        <tr height="50"/>
                    
                        <tr className="pagetop6">
                            <td className="activetenants width30" colSpan={3} height="50" valign="left">{Translate("Bought licenses")}</td>
                            <td colSpan={2} align="right">
                                <table className="blackbackground borderradius">
                                    <tbody>
                                        <tr className="pointer" onClick={()=>BuyLicence()}>
                                            <td width="8"/>
                                            <td><img className="width50" src={PlusIcon} alt="plus icon"/></td>
                                            <td className="bold white">{Translate("Buy license")}</td>
                                            <td width="20"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>

                        <tr height="10"/>

                    </tbody>
                </table>

                <table className="width1200" cellPadding={0} cellSpacing={0} align="center" id="tenant-licences" >
                    <tbody>
                        <tr>
                            <td className="tenantlicencetableheader borderleft bordertop borderright">{Translate("License")}</td>
                            <td className="tenantlicencetableheader tenantlicencetableheaderdescription  bordertop borderright">{Translate("Description")}</td>
                            <td className="tenantlicencetableheader tenantlicencetableheaderQuantity bordertop borderright">{Translate("Quantity")}</td>
                            <td className="tenantlicencetableheader tenantlicencetableheaderQuantity bordertop borderright">{Translate("Expire")}</td>
                        </tr>

                        {mLicenceList && mLicenceList.length > 0 ? (
                        mLicenceList.map((licence, index) => (
                        <tr  key={index}>
                            <td className="borderleft borderbottom bold">{licence.Name}</td>
                            <td className="borderleft borderbottom">{licence.Description}</td>
                            <td className="borderleft borderbottom paddingleft">{licence.Count}</td>
                            <td className="borderleft borderbottom borderright">
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <img alt="Close" width="30" src={CloseLogo} />
                                    <span
                                        className="paddingleft underline pointer"
                                        onClick={() => ShowAnimationExpireLicense(licence)}
                                    >
                                        {Translate("Expire")}
                                    </span>
                                </div>
                            </td>
                        </tr>))):(

                        <tr>
                            <td className="borderleft borderbottom borderright bold" align="center" colSpan={5}>{Translate("No license available")}</td>
                        </tr>)}

                        <tr>
                            <td colSpan={4} height="80"></td>
                        </tr>

                        <tr>
                            <td colSpan={4} className="activetenants width30"  height="50" valign="left">{Translate("Users")}</td>
                        </tr>

                        <tr>
                            <td className="width30" colSpan={2} height="50" valign="left">
                                <input id="searchvalue" value={mUserSearchValue} type="text" placeholder={Translate("Search") ?? ""} className="searchtenants" onChange={evt => SetUserSearchValue(evt.target.value)} onKeyDown={handleKeyPress}/>
                                <img alt="Search" className="searchimage" src={SearchButton} onClick={() => SetRepaint(!mRepaint)} />
                            </td>
                            <td colSpan={2} align="right" width="323">
                                <table className="blackbackground borderradius">
                                    <tbody>
                                        <tr className="pointer" onClick={()=>AddNewUserButton(mTenant.TenantGuid)}>
                                            <td width="8"/>
                                            <td><img className="width50" src={PlusIcon} alt="plus icon"/></td>
                                            <td className="bold white">{Translate("Add user")}</td>
                                            <td width="20"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>

                        <tr height="10"/>

                    </tbody>
                </table>

                <table className="width1200" cellPadding={0} cellSpacing={0} align="center" border="1" id="users-table">
                    <tbody>

                        <tr>
                            <td className="tenantusertable tenantusertableheadername borderleft" >{Translate("Name")}</td>
                            <td className="tenantusertable tenantusertableheadername"></td>
                            <td className="tenantusertable tenantusertableheadername"></td>
                            <td className="tenantusertable tenantusertableheadername" >{Translate("E-mail / Sign-in")}</td>
                            <td className="tenantusertable tenantusertableheadername " >{Translate("Assigned license")}</td>
                            <td colSpan={3} className="tenantusertable ">{Translate("Change")}</td>
                        </tr>

                        {FilteredUserList.length > 0 ? (
                        FilteredUserList.sort((a,b) => a.Name.localeCompare(b.Name)).map((user, index) => (
                        <tr height="60" key={index} className={user.IsActive ? "" : "lightfontcolor"}>
                            <td className="bordertop tenantusertablecontent borderbottom bold underline pointer">
                                <a
                                    href={`../user?userguid=${user.UserGuid}&tenantguid=${mTenantGuid}`}
                                    className="username-link"
                                    rel="noopener noreferrer"
                                >
                                    {user.Name}
                                </a>
                                </td>
                            <td className="bordertop">{user.IsRecognitionAdmin ? <img className="CRMAdminlogo" alt="CRMLogo" src={CRMAdminlogo} title="CRM administrator"/> : ""}</td>
                            <td className="bordertop">{user.IsTenantAdmin ? <img className="TenantAdminLogo" alt="TenantAdminLogo" src={TenantAdminLogo} title="Tenant administrator"/> : ""}</td>
                            <td className=" bordertop tenantusertablecontent borderbottom">{user.Email}</td>
                            <td className=" bordertop tenantusertablecontent underlinetext borderbottom">{user.LicenceName}</td>
                            <td className="bordertop borderbottom">
                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <table width="100%">
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <img align="right" alt="edit" src={EditLogo}></img>
                                                            </td>
                                                            <td className="underlinetext tenantusertableedit pointer" onClick={() => navigate('../edituser?userguid=' + user.UserGuid + '&tenantguid=' + mTenantGuid)}>{Translate("Edit")}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                            <td><img className="trashwidth" align="right" alt="DeleteLogo" src={DeleteIcon}></img></td>
                                            <td align="left" valign="center" className="underlinetext tenantusertableedit pointer" onClick={() => deleteUserHandler(user)}>{Translate("Delete")}</td>
                                            <td><img className="trashwidth" alt="InviteLogo" src={Envelop}></img></td>
                                            <td align="left" valign="center" className="underlinetext tenantusertableedit pointer" onClick={() => InviteUser(user)}>{Translate("Invite")}</td>
                                            <td><img className="trashwidth" align="right" alt="BlockLogo" src={Block}></img></td>
                                            <td width="*" align="left" valign="center" className={user.IsActive ? "underlinetext tenantusertableedit pointer" : "underlinetext tenantusertableedit pointer red"} 
                                                onClick={() => BlockUser(user)}>
                                                {user.IsActive ? Translate("Block sign-in") : Translate("Unblock sign-in")}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        ))
                        ) : (
                        <tr>
                            <td className="borderleft borderbottom  bold" align="center" colSpan={7}>{Translate("No user found")}</td>
                        </tr>
                        )}            
                </tbody>
            </table>                    

            <table>
                <tbody>
                    <tr height="30"/>
                </tbody>
            </table>          
            
            {/*Delete Tenant Table*/}
            { mShowDeleteTenantTable && (
            <table className="width1200 cloudctibackgroundtable" cellPadding={0} cellSpacing={0} align="center">
                <tbody>
                    <tr height="20" ></tr>
                    <tr>
                        <td width="40"></td>
                        <td>
                            <table>
                                <tbody>
                                    <tr>
                                        <td><img className="DeleteIcon" alt="Close" width="20" src={CloseLogoDelete}/></td>
                                        <td className="bold fontsizelarge paddingleft paddingbottom">{Translate("Delete this tenant")}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr height="20" />
                    <tr height="20"></tr>
                    <tr>
                        <td width="40"></td>
                        <td className="bold fontsizesmall">
                            <button className="red white pointer borderradios btn btn-dark" onClick={()=>{handleDeleteTenant(mTenantGuid)}}>{Translate("Delete this tenant")}</button> 
                        </td>
                    </tr>
                    <tr height="40"/>
                </tbody>
            </table>)}
            
            {/*Footer Table*/}
            <table>
                <tbody>
                    <tr height="60"></tr>
                </tbody>
            </table>

            <Footer/>
                            
            {/*Animation part of expiring licences*/}
            <Modal animation={false} style={{opacity:1}} show={mShowGetLicenseCount !== false} onHide={() => {SetExpireLicence("");SetShowGetLicenseCount(false)}} centered={true}>
                <Modal.Header closeButton={true}>
                    <Modal.Title align="center"><span align="center">{("How many licenses do you want to expire?")}</span></Modal.Title>
                </Modal.Header>
                <Modal.Body align="center">
                    <table className="scriptitembody">  
                        <tbody>                                         
                            <tr>
                                <td width="150">{Translate("License amount")}</td> 
                                <td width="*"><input autoComplete="new-password" type="text" value={mExpireLicenceCount} onChange={evt => SetExpireLicenceCount(evt.target.value)}/></td>
                            </tr>    
                        </tbody>       
                    </table> 
                    <br/>
                </Modal.Body>
                <Modal.Footer align="center">
                    <Button variant="dark" onClick={() => {ExpireLicence()}}>OK</Button>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                    <Button variant="dark" onClick={() => {SetExpireLicence("");SetShowGetLicenseCount(false)}}>Cancel</Button>
                </Modal.Footer>
            </Modal>

            {/*Animation for deleting a user*/}
            <Modal animation={false} style={{opacity:1}} show={mDeleteUser !== ""} onHide={() => {SetDeleteUser("")}} centered={true}>
                <Modal.Header closeButton={true}>
                    <Modal.Title align="center"><span align="center">{("Are you sure you want to delete this user")}</span></Modal.Title>
                </Modal.Header>

                <Modal.Footer align="center">
                    <Button variant="dark" onClick={() => {DeleteUser()}}>{Translate("Delete")}</Button>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                    <Button variant="dark" onClick={() => {SetDeleteUser("")}}>Cancel</Button>
                </Modal.Footer>
            </Modal>

            {/*Animation for deleting a tenant*/}
            <Modal animation={false} style={{opacity:1}} show={mDeletedTenantGuid !== ""} onHide={() => SetDeletedTenantGuid("")} centered={true}>
                <Modal.Header closeButton={true}>
                    <Modal.Title align="center"><span align="center">{("Are you sure you want to delete this tenant?")}</span></Modal.Title>
                </Modal.Header>
                <Modal.Footer align="center">
                    <Button variant="dark" onClick={() => {DeleteTenant()}}>{Translate("Delete")}</Button>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                    <Button variant="dark" onClick={() => {SetDeletedTenantGuid("")}}>Cancel</Button>
                </Modal.Footer>
            </Modal>

             {/*Animation for sending invitation email for a user*/}
             <Modal animation={false} style={{opacity:1}} show={mInvitedUser !== ""} onHide={() => SetInvitedUser("")} centered={true}>
                <Modal.Header closeButton={true}>
                    <Modal.Title align="center"><span align="center">{("Are you sure you want to send invitation email for this user?")}</span></Modal.Title>
                </Modal.Header>
                <Modal.Footer align="center">
                    <Button variant="dark" onClick={() => {SendEmail()}}>{Translate("Send")}</Button>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                    <Button variant="dark" onClick={() => {SetInvitedUser("")}}>Cancel</Button>
                </Modal.Footer>
            </Modal>

            {/*Animation for deleting a reseller tenant*/}
            <Modal animation={false} style={{opacity:1}} show={mDeletingAResellerTenant === true} onHide={() => SetDeletingAResellerTenant(false)} centered={true}>
                <Modal.Header closeButton={true}>
                    <Modal.Title align="center"><span align="center">{("This is a reseller tenant and may have a group of assigned tenants. Are you sure you want to proceed with deleting this reseller?")}</span></Modal.Title>
                </Modal.Header>
                <Modal.Footer align="center">
                    <Button variant="dark" onClick={() => {DeleteTenant()}}>{Translate("Delete")}</Button>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                    <Button variant="dark" onClick={() => {SetDeletingAResellerTenant(false)}}>{Translate("Cancel")}</Button>
                </Modal.Footer>
            </Modal>

            {/*Animation for showing the error of expiring the lincese or licenses.*/}
            <Modal animation={false} style={{opacity:1}} show={mExpringLicenseError !== ""} onHide={() => SetExpringLicenseError("")} centered={true}>
                <Modal.Header closeButton={true}>
                    <Modal.Title align="center">
                        <span align="center">
                            {mExpringLicenseError}
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Footer style={{ justifyContent: "center" }}>
                    <Button variant="dark" onClick={() => { SetExpringLicenseError(""); SetShowGetLicenseCount(true); }}>
                        {Translate("Ok")}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/*Animation for showing the error of expiring the lincese or licenses that assigned to user or users.*/}
            <Modal animation={false} style={{opacity:1}} show={mExpringLicenseErrorCauseOfAssignedToUsers !== ""} onHide={() => SetExpringLicenseErrorCauseOfAssignedToUsers("")} centered={true}>
                <Modal.Header closeButton={true}>
                    <Modal.Title align="center">
                        <span align="center">
                            {mExpringLicenseErrorCauseOfAssignedToUsers}
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Footer style={{ justifyContent: "center" }}>
                    <Button variant="dark" onClick={() => {ExpireLicesesOfUsers()}}>{Translate("Proceed")}</Button>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                    <Button variant="dark" onClick={() => {SetExpringLicenseErrorCauseOfAssignedToUsers("")}}>{Translate("Cancel")}</Button>
                </Modal.Footer>
            </Modal>

            {/*Animation for showing the error of editing a tenant.*/}
            <Modal animation={false} style={{opacity:1}} show={mShowPopUpErrorEditingTenant !== ""} onHide={() => SetShowPopUpErrorEditingTenant("")} centered={true}>
                <Modal.Header closeButton={true}>
                    <Modal.Title align="center"><span align="center">{mShowPopUpErrorEditingTenant}</span></Modal.Title>
                </Modal.Header>
                <Modal.Footer align="center">
                    <Button variant="dark" onClick={() => {SetShowPopUpErrorEditingTenant("")}}>{Translate("Ok")}</Button>
                </Modal.Footer>
            </Modal>

            {/* Animation for showing the error of deleting a tenant. */}
            <Modal animation={false} style={{ opacity: 1 }} show={mShowPopUpErrorDeletingTenant !== ""} onHide={() => SetShowPopUpErrorDeletingTenant("")} centered={true}>
                <Modal.Header closeButton />
                <Modal.Body>
                    <div style={{ textAlign: "center" }}>{mShowPopUpErrorDeletingTenant}</div>
                </Modal.Body>
                <Modal.Footer>
                    <div style={{ width: "100%", textAlign: "center" }}>
                        <Button variant="dark" onClick={() => SetShowPopUpErrorDeletingTenant("")}>
                            {Translate("Ok")}
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>


            {/*Animation for showing the error of buying licenses.*/}
            <Modal
                animation={false}
                style={{ opacity: 1 }}
                show={mShowPopUpErrorBuyingLicenses !== ""}
                onHide={() => SetShowPopUpErrorBuyingLicenses("")}
                centered={true}
                >
                <Modal.Header closeButton />

                <Modal.Body className="text-center">
                    <span>{mShowPopUpErrorBuyingLicenses}</span>
                </Modal.Body>

                <Modal.Footer className="justify-content-center">
                    <Button variant="dark" onClick={() => SetShowPopUpErrorBuyingLicenses("")}>
                    {Translate("Ok")}
                    </Button>
                </Modal.Footer>
            </Modal>

    </div>)
    }
}

export default Tenant